export let Confetti = {
    lazyLaunchRealistic: () => {
        import('canvas-confetti').then(confettiFactory => {
            const myCanvas = document.createElement('canvas');
            document.body.appendChild(myCanvas);

            myCanvas.style.position = 'fixed';
            myCanvas.style.top = '0';
            myCanvas.style.left = '0';
            myCanvas.style.width = '100vw';
            myCanvas.style.height = '100vh';
            myCanvas.style.zIndex = '10000';
            myCanvas.style.pointerEvents = 'none'; // Prevent interaction issues

            let confetti = confettiFactory.create(myCanvas, {
                resize: true, // Make the canvas cover the full screen
                useWorker: true, // Improves performance
            })
            let count = 200;
            let defaults = {
                origin: {y: 0.7}
            };

            function fire(particleRatio, opts) {
                confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio),
                    zIndex: 9999
                });
            }

            fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            fire(0.2, {
                spread: 60,
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        });

    }
}